<template lang="pug">
    .event-form-section
        .summary(v-if="events && events.length")
            .multiple-events(v-if="events.length > 1")
                .field
                    label.label Event
                    multiselect(
                        v-model="event"
                        :options="events"
                        track-by="id"
                        label="label"
                        :allow-empty="false"
                        placeholder="auswählen..."
                        deselect-label=""
                        selected-label="ausgewählt"
                        select-label="mit Enter auswählen"
                    )
            .single-event(v-else-if="event")
                h3.is-size-4-desktop.is-size-5-tablet.is-size-6-mobile.has-text-weight-light {{ event.name }}
                    small {{ event.category.name }}
            .slot(v-if="slot")
                .date
                    p(v-if="slot.start_date === slot.end_date")
                        | {{ slot.start_date * 1000 | formatDate }},
                        | {{ slot.start_time * 1000 | formatDate('HH:mm') }} - {{ slot.end_time * 1000 | formatDate('HH:mm') }} Uhr
                    p(v-else)
                        | {{ slot.start_date * 1000 | formatDate }},
                        | {{ slot.start_time * 1000 | formatDate('HH:mm') }} -
                        | {{ slot.end_date * 1000 | formatDate }},
                        | {{ slot.end_time * 1000 | formatDate('HH:mm') }}
            .description(v-if="event && event.description" v-html="event.description")
            .address(v-if="hasAddress(event)")
                h3.is-size-4-desktop.is-size-5-tablet.is-size-6-mobile.has-text-weight-light Adresse
                .street(v-if="event.address.street") {{ event.address.street }}
                .city(v-if="event.address.zipcode || event.address.city")
                    span.zipcode(v-if="event.address.zipcode") {{ event.address.zipcode }}&nbsp;
                    span.city(v-if="event.address.city") {{ event.address.city }}
                .country(v-if="event.address.country") {{ event.address.country | iso }}
        .booking-form(v-if="recaptchaSiteKey && restriction === 'none' && booking !== 'none'")
            loading(:active="loading" :is-full-page="false" :height="40" :width="40" color="#000000")
            validation-observer(v-slot="{ invalid }" ref="form")
                form(@submit.prevent="submit")
                    // TODO: validate hidden fields for selected event and slot
                    .columns
                        .field.column
                            validation-provider(name="Vorname" rules="required" v-slot="{ errors }")
                                label.label(for="first-name") Vorname
                                .control.has-icons-right
                                    input#first-name.input(
                                        type="text"
                                        name="first_name"
                                        v-model="form.booker.first_name"
                                        :class="{ 'is-danger': errors && errors.length }"
                                    )
                                    span.icon.is-small.is-right
                                        i.fas.fa-user
                                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                                p.help.has-text-grey(v-else) Pflichtfeld
                        .field.column
                            validation-provider(name="Nachname" rules="required" v-slot="{ errors }")
                                label.label(for="last-name") Nachname
                                .control.has-icons-right
                                    input#last-name.input(
                                        type="text"
                                        name="last_name"
                                        v-model="form.booker.last_name"
                                        :class="{ 'is-danger': errors && errors.length }"
                                    )
                                    span.icon.is-small.is-right
                                        i.fas.fa-user
                                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                                p.help.has-text-grey(v-else) Pflichtfeld
                    .columns
                        .field.column
                            validation-provider(name="E-Mail Adresse" rules="required|email" v-slot="{ errors }")
                                label.label(for="email") E-Mail Adresse
                                .control.has-icons-right
                                    input#email.input(
                                        type="email"
                                        name="email"
                                        v-model="form.booker.email"
                                        :class="{ 'is-danger': errors && errors.length }"
                                    )
                                    span.icon.is-small.is-right
                                        i.fas.fa-envelope
                                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                                p.help.has-text-grey(v-else) Pflichtfeld
                        .field.column
                            label.label(for="phone") Telefon
                            .control.has-icons-right
                                input#phone.input(type="text" v-model="form.booker.phone")
                                span.icon.is-small.is-right
                                    i.fas.fa-phone
                    .field
                        label.label(for="message") Ihre Nachricht
                        .control
                            textarea.textarea(
                                name="message"
                                v-model="form.message"
                            )
                    .columns
                        .field.column.is-8
                            validation-provider(name="Datenschutzbestimmungen" :rules="{ required: { allowFalse: false } }" v-slot="{ errors }")
                                .control
                                    label.checkbox
                                        input(
                                            type="checkbox"
                                            name="terms"
                                            v-model="form.terms"
                                            :class="{ 'is-danger': errors && errors.length }"
                                        )
                                        |  Ich stimme den Datenschutzbestimmungen zu
                                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                                p.help.has-text-grey(v-else) Pflichtfeld
                        .field.column.is-4
                            .control
                                button.button.is-pulled-right.is-primary(type="submit" :disabled="invalid") Absenden
        .no-booking(v-else-if="booking === 'none'")
            // no booking form
        .contactpage(v-else)
            .notification.is-light
                | Aus technischen Gründen ist das Anmeldeformular vorübergehend deaktiviert. <br>
                | Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.
</template>

<script>
    import _ from 'lodash'

    import Vue from 'vue'
    import store from '@/store'

    import { mapGetters, mapMutations, mapActions } from 'vuex'
    import { VueReCaptcha } from 'vue-recaptcha-v3'
    import { ValidationObserver, ValidationProvider } from 'vee-validate'

    import Loading from 'vue-loading-overlay'
    import Multiselect from 'vue-multiselect'

    import countries from 'i18n-iso-countries'
    import de from 'i18n-iso-countries/langs/de.json'

    countries.registerLocale(de)

    export default {
        name: 'Form',
        data() {
            return {
                loading: false,
                form: {
                    // event: undefined,
                    // slot: undefined,
                    // member: undefined,
                    booker: {
                        first_name: '',
                        last_name: '',
                        email: '',
                        phone: ''
                    },
                    message: '',
                    terms: false
                }
            }
        },
        components: {
            Loading,
            Multiselect,
            ValidationObserver,
            ValidationProvider,
        },
        props: {
            section: {
                type: Object
            }
        },
        computed: {
            events() {
                const categories = _.get(this.section, 'eventCategories') || []
                const events = []
                categories.forEach(category => {
                    const catEvents = _.get(category, 'events') || []
                    catEvents.forEach(event => {
                        events.push({
                            ...event,
                            ...{ category: { id: category.id, name: category.name }},
                            ...{ label: `${event.name} - ${category.name}` }
                        })
                    })
                })

                return events
            },
            event: {
                get() {
                    if (this.selections[this.$route.path] && this.selections[this.$route.path].event)
                        return this.selections[this.$route.path].event
                },
                set(event) {
                    this.selectEvent({ key: this.$route.path, event })
                    // this.$router.push({query: { id: event.id }})
                }
            },
            slot() {
                if (this.selections[this.$route.path] && this.selections[this.$route.path].slot)
                    return this.selections[this.$route.path].slot
            },
            restriction() {
                return _.get(this.event, 'restriction') || 'none'
            },
            booking() {
                return _.get(this.event, 'booking') || 'none'
            },
            ...mapGetters({
                recaptchaSiteKey: 'googleRecaptchaSiteKey',
                selections: 'eventManager/selections',
                cms: 'CMS'
            }),
        },
        filters: {
            iso(value) {
                return countries.getName(value, 'de')
            },
        },
        methods: {
            async submit() {
                const valid = await this.$refs.form.validate()
                if (valid && this.recaptchaSiteKey) {
                    if (!this.slot) {
                        const message = {
                            id: _.uniqueId(),
                            title: 'Fehler',
                            text: `
                                Wählen Sie einen Termin durch Anklicken im Kalendar aus.<br>
                                <i>Please select an appointment by clicking on it in the calendar</i>
                            `,
                            type: 'danger',
                            autoclose: 5000
                        };
                        store.commit('addMessage', message)
                    } else {
                        this.loading = true
                        try {
                            await this.$recaptchaLoaded()
                            const token = await this.$recaptcha('event')

                            const payload = {
                                event: this.event.label,
                                message: this.form.message,
                                slot: { id: this.slot.id },
                                booker: this.form.booker,
                            }
                            this.createBooking(payload)
                                .then(() => {
                                    // TODO:
                                    // 1. show success message
                                    // 2. clear form
                                    // 3. increment booked number in slot

                                    const message = {
                                        id: _.uniqueId(),
                                        title: 'Erfolgreich',
                                        text: 'Ihre Anmeldung wurde erfolgreich versendet.',
                                        type: 'success',
                                        autoclose: 5000
                                    };
                                    store.commit('addMessage', message)

                                    this.form = {
                                        // event: undefined,
                                        // slot: undefined,
                                        // member: undefined,
                                        booker: {
                                            first_name: '',
                                            last_name: '',
                                            email: '',
                                            phone: ''
                                        },
                                        message: '',
                                        terms: false
                                    }

                                    this.$refs.form.reset()

                                    // this.refreshMenuItem({ path, cms })

                                    const data = {
                                        key: this.section.key,
                                        eID: this.event.id,
                                        cID: this.event.category.id,
                                        sID: this.slot.id,
                                        booking: { id: 'new' },
                                    }
                                    this.addBookingToSlot(data)

                                    this.$nextTick(() => {
                                        const event = this.events.find(event => event.id === this.event.id)
                                        const slot = this.slot

                                        this.selectEvent({ key: this.$route.path, event })
                                        // this.selectSlot({ key: this.$route.path, slot })
                                    })
                                })
                                .catch(() => {
                                    const message = {
                                        id: _.uniqueId(),
                                        title: 'Fehler',
                                        text: 'Ihre Anmeldung konnte nicht verarbeitet werden.',
                                        type: 'danger',
                                        autoclose: 5000
                                    };
                                    store.commit('addMessage', message)
                                })
                                .finally(() => {
                                    this.loading = false
                                })
                        } catch (error) {
                            console.error(error);
                            const message = {
                                id: _.uniqueId(),
                                title: 'Fehler',
                                text: 'Es gibt ein technisches Problem. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                                type: 'danger',
                                autoclose: 5000
                            };
                            store.commit('addMessage', message)
                            this.loading = false
                        }
                    }
                }
            },
            hasAddress(event) {
                return event && event.address && event.address.street && event.address.city
            },
            ...mapMutations({
                updateFormDetails: 'eventManager/updateFormDetails',
                selectEvent: 'eventManager/selectEvent',
                selectSlot: 'eventManager/selectSlot',
                addBookingToSlot: 'currentPage/addBookingToEventSectionSlot',
            }),
            ...mapActions({
                createBooking: 'eventManager/createBooking',
                refreshMenuItem: 'currentPage/refreshMenuItem',
            })
        },
        beforeMount() {
            if (this.recaptchaSiteKey) {
                Vue.use(VueReCaptcha, {
                    siteKey: this.recaptchaSiteKey,
                    loaderOptions: {
                        useRecaptchaNet: true
                    }
                })
            }
        },
        mounted() {
            if (this.events && this.events.length && ! this.selections[this.$route.path]) {
                let event

                const id = _.get(this.$route.query, 'id')
                if (id) event = this.events.find(event => parseInt(event.id) === parseInt(id))
                if (!event) event = this.events[0]

                this.selectEvent({ key: this.$route.path, event })
            }
        },
    }
</script>

<style lang="sass" scoped>
    @import '~@/assets/sass/variables';
    @import "~bulma/sass/utilities/mixins";

    .booking-form
        position: relative
    .summary
        margin-bottom: 1rem
    .address
        margin-top: 2rem
    h3 small
        display: block
        // font-size: .8em
        font-size: 1rem
        color: grey
        line-height: 1
    .single-event > h3
        margin-bottom: 2rem
    .slot,
    .multiple-events
        margin-bottom: 1rem
</style>
